
import VueRouter from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/Index',
        name: 'index',
        component: () => import('@/layout/Index.vue'),
        redirect: 'Home', // 👈 只加这一行！！！ 跳转首页
        children: [
            {
                path: '/Home',
                name: 'home',
                meta: {
                    title: '首页'
                },
                component: () => import('@/layout/Home.vue')
            },
            //用户服务
            {
                path: '/userServices/userServe',
                name: 'userServe',
                meta: {
                    title: '用户信息管理'
                },
                component: () => import('@/page/userServices/userServe.vue')
            },
            {
                path: '/userServices/userInformation',
                name: 'userInformation',
                meta: {
                    title: '个人信息'
                },
                component: () => import('@/page/userServices/userInformation.vue')
            },
            {
                path: '/userServices/CollegeManagement',
                name: 'collegeManagement',
                meta: {
                    title: '学院管理'
                },
                component: () => import('@/page/userServices/collegeManagement.vue'),
            },
            {
                path: '/userServices/Major',
                name: 'Major',
                meta: {
                    title: '专业管理'
                },
                component: () => import('@/page/userServices/Major.vue')
            },
            //报名服务
            {
                path: '/userServices/titleManagement',
                name: 'titleManagement',
                meta: {
                    title: '头衔管理'
                },
                component: () => import('@/page/userServices/titleManagement.vue')
            },
            //部门服务
            {
                path: '/departmentalServices/departmentManagement',
                name: 'departmentManagement',
                meta: {
                    title: '部门管理'
                },
                component: () => import('@/page/departmentalServices/departmentManagement.vue')
            },
            {
                path: '/departmentalServices/departmentalRoleManagement',
                name: 'departmentalRoleManagement',
                meta: {
                    title: '部门角色管理'
                },
                component: () => import('@/page/departmentalServices/departmentalRoleManagement.vue')
            },
            {
                path: '/departmentalServices/detailedDepartmentalManagement',
                name: 'detailedDepartmentalManagement',
                meta: {
                    title: '部门详细管理'
                },
                component: () => import('@/page/departmentalServices/detailedDepartmentalManagement.vue')
            },
            {
                path: '/departmentalServices/departmentUserRelationship',
                name: 'departmentUserRelationship',
                meta: {
                    title: '管理成员'
                },
                component: () => import('@/page/departmentalServices/departmentUserRelationship.vue')
            },
            //cms服务
            {
                path: '/registrationService/registrationManagement',
                name: 'registrationManagement',
                meta: {
                    title: '新生录取'
                },
                component: () => import('@/page/registrationService/RecruitmentManagement.vue')
            },
            {
                path: '/registrationService/selectUser',
                name: 'selectUserPage',
                meta: {
                    title: '查询老成员'
                },
                component: () => import('@/page/registrationService/SelectUser.vue')
            },
            {
                path: '/cmsService/carouselManagement',
                name: 'carouselManagement',
                meta: {
                    title: '轮播图管理'
                },
                component: () => import('@/page/cmsService/carouselManagement.vue')
            },
            {
                path: '/aiService',
                name: 'aiService',
                meta: {
                    title: 'AI管理'
                },
                component: () => import('@/page/aiService/aiService.vue')
            },
            {
                path: '/cmsService/AssociationMembers',
                name: 'AssociationMembers',
                meta: {
                    title: '优秀成员管理'
                },
                component: () => import('@/page/cmsService/AssociationMembers.vue')
            },
            {
                path: '/cmsService/teacherManagement',
                name: 'teacherManagement',
                meta: {
                    title: '指导老师管理'
                },
                component: () => import('@/page/cmsService/teacherManagement.vue')
            },
            {
                path: '/cmsService/actionManagement',
                name: 'actionManagement',
                meta: {
                    title: '活动管理'
                },
                component: () => import('@/page/cmsService/actionManagement.vue')
            },
            {
                path: '/cmsService/noticeManagement',
                name: 'noticeManagement',
                meta: {
                    title: '公告管理'
                },
                component: () => import('@/page/cmsService/noticeManagement.vue')
            },
            {
                path: '/cmsService/feedbackManagement',
                name: 'feedbackManagement',
                meta: {
                    title: '反馈管理'
                },
                component: () => import('@/page/cmsService/feedbackManagement.vue')
            },
            //问答服务
            {
                path: '/q&aService/postTypeManagement',
                name: 'postTypeManagement',
                meta: {
                    title: '帖子类型管理'
                },
                component: () => import('@/page/q&aService/postTypeManagement.vue')
            },
            {
                path: '/q&aService/subComment',
                name: 'subComment',
                meta: {
                    title: '子评论管理'
                },
                component: () => import('@/page/q&aService/subComment.vue')
            },
            {
                path: '/q&aService/fatherComment',
                name: 'fatherComment',
                meta: {
                    title: '父评论管理'
                },
                component: () => import('@/page/q&aService/fatherComment.vue')
            },
            {
                path: '/q&aService/postsManagement',
                name: 'postsManagement',
                meta: {
                    title: '帖子管理'
                },
                component: () => import('@/page/q&aService/postsManagement.vue')
            },
            {
                path:'/studyServices/studyContentManagement',
                name:'studyContentManagement',
                meta: {
                    title: '学习资料管理'
                },
                component: () => import('@/page/studyServices/studyContentManagement.vue')
            },
            {
                path:'/studyServices/studyTypeManagement',
                name:'studyTypeManagement',
                meta: {
                    title: '学习资料类型管理'
                },
                component: () => import('@/page/studyServices/studyTypeManagement.vue')
            },
            // 社团服务
            {
                path:'/organizationsService/organizationsManagement',
                name:'organizationsManagement',
                meta: {
                    title: '社团管理'
                },
                component: () => import('@/page/organizationsService/organizationsManagement.vue')
            },
            {
                path:'/organizationsService/clubVisualization',
                name:'clubVisualization',
                meta: {
                    title: '社团数据可视化'
                },
                component: () => import('@/page/organizationsService/clubVisualization.vue')
            },
            {
                path:'/classroom/appointmentApproval',
                name:'appointmentApproval',
                meta: {
                    title: '预约审批'
                },
                component: () => import('@/page/classroom/appointmentApproval/appointmentApproval.vue')
            },
            {
                path:'/classroom/idleClassroom',
                name:'idleClassroom',
                meta: {
                    title: '空闲教室'
                },
                component: () => import('@/page/classroom/idleClassroom/idleClassroom.vue')
            },
        ]
    }
]

// const adminRoutes = [
//     {
//         path: '/',
//         name: 'login',
//         component: () => import('@/views/Login.vue')
//     },
//     {
//         path: '/Index',
//         name: 'index',
//         component: () => import('@/layout/Index.vue'),
//         children: [
//             {
//                 path: '/Home',
//                 name: 'home',
//                 meta: {
//                     title: '首页'
//                 },
//                 component: () => import('@/layout/Home.vue')
//             },
//             //用户服务
//             {
//                 path: '/userServices/userServe',
//                 name: 'userServe',
//                 meta: {
//                     title: '用户信息管理'
//                 },
//                 component: () => import('@/page/userServices/userServe.vue')
//             },
//             {
//                 path: '/userServices/userInformation',
//                 name: 'userInformation',
//                 meta: {
//                     title: '个人信息'
//                 },
//                 component: () => import('@/page/userServices/userInformation.vue')
//             },
//             {
//                 path: '/userServices/CollegeManagement',
//                 name: 'collegeManagement',
//                 meta: {
//                     title: '学院管理'
//                 },
//                 component: () => import('@/page/userServices/collegeManagement.vue'),
//             },
//             {
//                 path: '/userServices/Major',
//                 name: 'Major',
//                 meta: {
//                     title: '专业管理'
//                 },
//                 component: () => import('@/page/userServices/Major.vue')
//             },
//             //报名服务
//             {
//                 path: '/userServices/titleManagement',
//                 name: 'titleManagement',
//                 meta: {
//                     title: '头衔管理'
//                 },
//                 component: () => import('@/page/userServices/titleManagement.vue')
//             },
//             //部门服务
//             {
//                 path: '/departmentalServices/departmentManagement',
//                 name: 'departmentManagement',
//                 meta: {
//                     title: '部门管理'
//                 },
//                 component: () => import('@/page/departmentalServices/departmentManagement.vue')
//             },
//             {
//                 path: '/departmentalServices/departmentalRoleManagement',
//                 name: 'departmentalRoleManagement',
//                 meta: {
//                     title: '部门角色管理'
//                 },
//                 component: () => import('@/page/departmentalServices/departmentalRoleManagement.vue')
//             },
//             {
//                 path: '/departmentalServices/detailedDepartmentalManagement',
//                 name: 'detailedDepartmentalManagement',
//                 meta: {
//                     title: '部门详细管理'
//                 },
//                 component: () => import('@/page/departmentalServices/detailedDepartmentalManagement.vue')
//             },
//             {
//                 path: '/departmentalServices/departmentUserRelationship',
//                 name: 'departmentUserRelationship',
//                 meta: {
//                     title: '用户与部门的联系'
//                 },
//                 component: () => import('@/page/departmentalServices/departmentUserRelationship.vue')
//             },
//             //cms服务
//             {
//                 path: '/registrationService/registrationManagement',
//                 name: 'registrationManagement',
//                 meta: {
//                     title: '报名管理'
//                 },
//                 component: () => import('@/page/registrationService/registrationManagement.vue')
//             },
//             {
//                 path: '/cmsService/carouselManagement',
//                 name: 'carouselManagement',
//                 meta: {
//                     title: '轮播图管理'
//                 },
//                 component: () => import('@/page/cmsService/carouselManagement.vue')
//             },
//             {
//                 path: '/cmsService/AssociationMembers',
//                 name: 'AssociationMembers',
//                 meta: {
//                     title: '优秀协会成员管理'
//                 },
//                 component: () => import('@/page/cmsService/AssociationMembers.vue')
//             },
//             {
//                 path: '/cmsService/teacherManagement',
//                 name: 'teacherManagement',
//                 meta: {
//                     title: '老师管理'
//                 },
//                 component: () => import('@/page/cmsService/teacherManagement.vue')
//             },
//             {
//                 path: '/cmsService/actionManagement',
//                 name: 'actionManagement',
//                 meta: {
//                     title: '活动管理'
//                 },
//                 component: () => import('@/page/cmsService/actionManagement.vue')
//             },
//             {
//                 path: '/cmsService/noticeManagement',
//                 name: 'noticeManagement',
//                 meta: {
//                     title: '公告管理'
//                 },
//                 component: () => import('@/page/cmsService/noticeManagement.vue')
//             },
//             {
//                 path: '/cmsService/feedbackManagement',
//                 name: 'feedbackManagement',
//                 meta: {
//                     title: '反馈管理'
//                 },
//                 component: () => import('@/page/cmsService/feedbackManagement.vue')
//             },
//             //问答服务
//             {
//                 path: '/q&aService/postTypeManagement',
//                 name: 'postTypeManagement',
//                 meta: {
//                     title: '帖子类型管理'
//                 },
//                 component: () => import('@/page/q&aService/postTypeManagement.vue')
//             },
//             {
//                 path: '/q&aService/subComment',
//                 name: 'subComment',
//                 meta: {
//                     title: '子评论管理'
//                 },
//                 component: () => import('@/page/q&aService/subComment.vue')
//             },
//             {
//                 path: '/q&aService/fatherComment',
//                 name: 'fatherComment',
//                 meta: {
//                     title: '子评论管理'
//                 },
//                 component: () => import('@/page/q&aService/fatherComment.vue')
//             },
//             {
//                 path: '/q&aService/postsManagement',
//                 name: 'userServe',
//                 meta: {
//                     title: '帖子管理'
//                 },
//                 component: () => import('@/page/q&aService/postsManagement.vue')
//             },
//             {
//                 path:'/studyServices/studyContentManagement',
//                 name:'studyContentManagement',
//                 meta: {
//                     title: '学习内容管理'
//                 },
//                 component: () => import('@/page/studyServices/studyContentManagement.vue')
//             },
//             {
//                 path:'/studyServices/studyTypeManagement',
//                 name:'studyTypeManagement',
//                 meta: {
//                     title: '学习资料内容管理'
//                 },
//                 component: () => import('@/page/studyServices/studyTypeManagement.vue')
//             },
//             // 社团服务
//             {
//                 path:'/organizationsService/organizationsManagement',
//                 name:'organizationsManagement',
//                 meta: {
//                     title: '社团管理'
//                 },
//                 component: () => import('@/page/organizationsService/organizationsManagement.vue')
//             },
//         ]
//     }
// ]



const router = new VueRouter({
    routes
})

// 👇 就加在这里！
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
